export default __webpack_public_path__ + "static/imgTree-3dc127975290cb564adcca8d21412b22.webp";